import ContentTypes from '../enums/content.types';
import Model from './Model';

export default class MarkupModel extends Model {

	constructor(data) {
		super(data);

		if (data) {
			this.setData(data);
		} else {
			this.content = '';
			this.contentType = ContentTypes.MARKDOWN;
		}
	}

	setData(data) {
		this.content = data.content || '';
		if (data.contentType) {
			this.contentType = ContentTypes.getTypeFromString(data.contentType);
		} else {
			this.contentType = ContentTypes.MARKDOWN;
		}
	}

	get contentTypeName() {
		return this.contentType.name;
	}

	set contentTypeName(name) {
		this.contentType = ContentTypes.getTypeFromString(name);
	}

	build() {
		return {
			content    : this.content,
			contentType: this.contentType.code
		};
	}
};


// WEBPACK FOOTER //
// ./modules/distribution/core/models/MarkupModel.js